import Vue from 'vue';

// Register the v-pro directive
const directive = Vue.directive('pro', {
  bind(el, data) {
    if(!data.value) data.value = {};
    let { shiftRight, shiftUp, isPro } = data.value;

    if(!isPro && isPro !== undefined) return

    shiftRight = shiftRight || 0;
    shiftUp = shiftUp || 0;

    // Ensure the containing element can anchor absolutely positioned children
    if (window.getComputedStyle(el).position === 'static') {
      el.style.position = 'relative';
    }

    // Create the badge element

    const badge = document.createElement('span');
    badge.textContent = 'PRO';

    // Assign a class for easier CSS management (optional)
    badge.classList.add('v-pro-badge');

    // Inline styles (you can move these into a CSS class if preferred)
    badge.style.position = 'absolute';
    badge.style.top = ( 3 - shiftUp ) + 'px';
    badge.style.right = ( 3 - shiftRight) + 'px';
    badge.style.padding = '1px 6px';
    badge.style.background = '#2D57FB';
    badge.style.color = '#fff';
    badge.style.fontSize = '8px';
    badge.style.fontWeight = 'bold';
    badge.style.borderRadius = '2px';
    // badge.style.transform = 'translate(50%, -50%)';

    // Append the badge to the element
    el.appendChild(badge);
  },

  // If needed, you can manage removal or dynamic changes in other hooks
  // unbind(el) {
  //   // Example: remove all .v-pro-badge elements on unbind
  //   const badges = el.querySelectorAll('.v-pro-badge');
  //   badges.forEach((badge) => badge.remove());
  // }
});

export default directive;